import { Trash2 } from 'lucide-react'
import { toast } from 'sonner'
import { Button } from '@/components/ui/button'
import { useConfirm } from '@/components/common/ConfirmDialog'
import { usePermission } from '@/features/auth/store'
import { useDeactivateCustomer } from '../hooks'
import type { Customer } from '../types'

export function CustomerDeactivateButton({ customer }: { customer: Customer }) {
  const confirm = useConfirm()
  const canDelete = usePermission('partners.customer.delete')
  const deactivate = useDeactivateCustomer()
  if (!canDelete || !customer.isActive) return null

  const handleClick = async () => {
    const ok = await confirm({
      title: 'Deaktywować klienta?',
      description: `Klient "${customer.firstName ?? customer.name ?? customer.id}" zostanie dezaktywowany.`,
      confirmLabel: 'Dezaktywuj',
      variant: 'destructive',
    })
    if (!ok) return
    try {
      await deactivate.mutateAsync(customer.id)
      toast.success('Klient zdeaktywowany')
    } catch (err) {
      const msg = err instanceof Error ? err.message : 'Błąd'
      toast.error(`Nie udało się zdeaktywować: ${msg}`)
    }
  }

  return (
    <Button variant="outline" size="sm" className="gap-2 text-destructive hover:text-destructive" onClick={handleClick} disabled={deactivate.isPending}>
      <Trash2 className="size-4" />
      Deaktywuj
    </Button>
  )
}
